
<template>
  <div id="allprint">
    <div class="cominfo-header notPrint">企业中心 <span>/</span><span>学习计划</span><span>/</span><span>
        <router-link to="/Company/Plan">计划管理</router-link>
      </span></span><span>/</span><span>计划详情</span></div>
    <div class="deviceInfo notPrint">
      <div class="deviceInfo-header">
        <div>计划详情</div>
        <div>
          <el-button type="primary" @click="print">打印</el-button>
        </div>
      </div>
      <div class="deviceInfo-content disFlex">
        <div>
          <table class="boughtTable">
            <tr>
              <td class="boughtTd1">标题</td>
              <td colspan="5">{{planInfo.planname}}</td>
            </tr>
            <tr>
              <td class="boughtTd1">培训部门</td>
              <td colspan="3">{{planInfo.orgName}}</td>
              <td class="boughtTd1">培训类别</td>
              <td>{{planInfo.ontypeName}}</td>
            </tr>
            <tr>
              <td class="boughtTd1">培训方式</td>
              <td>{{planInfo.itype==1?'线上培训':'线下培训'}}</td>
              <td class="boughtTd1">课时</td>
              <td>{{planInfo.littletime}}</td>
              <td class="boughtTd1">培训人数</td>
              <td>{{planInfo.pnum}}</td>
            </tr>
            <tr>
              <td class="boughtTd1">{{planInfo.itype==1?'有效期':'时间'}}</td>
              <td colspan="5">{{planInfo.endtime}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="deviceInfo" v-if="planInfo.itype==2">
      <div class="deviceInfo-header">
        附件
      </div>
      <div class="deviceInfo-content disFlex">
        <div>
          <div v-for="(item,i) in fileList" :key="i" style="margin-bottom: 10px;">
            <el-link icon="el-icon-view" type="primary" :href="item.url" target="_blank">
              {{item.name}}
            </el-link>
          </div>
          <!-- <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
            :file-list="fileList">
          </el-upload> -->
        </div>
      </div>
    </div>

    <div class="deviceInfo" v-if="planInfo.itype=='1'">
      <div class="deviceInfo-header between">
        <div>关联课程信息</div>
      </div>
      <div class="deviceInfo-content kctable">
        <el-table :data="planInfo.ktProductPlanList" style="width: 100%">
          <el-table-column prop="img" label="封面" width="100">
            <template slot-scope="scope">
              <img :src="wjSrc+scope.row.img" style="width: 52px;height: 31px;border-radius: 3px;" />
            </template>
          </el-table-column>
          <el-table-column prop="productname" label="名称">
          </el-table-column>
          <el-table-column prop="itypeName" label="课程类别" width="180">
          </el-table-column>
          <el-table-column prop="allxstime" label="总课时" width="120">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="deviceInfo" v-if="planInfo.itype=='1'">
      <div class="deviceInfo-header between">
        <div>学员信息</div>
        <div style="height: 36px;" class="notPrint">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="">
              <el-input placeholder="请输入内容" v-model="formInline.keyword">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </el-form-item>
            <el-form-item label="" style="width: 130px;">
              <el-select v-model="formInline.kstate" clearable placeholder="全部状态">
                <el-option label="通过" value="0"></el-option>
                <el-option label="未通过" value="1"></el-option>
                <el-option label="未考试" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" style="width: 130px;">
              <el-button type="primary" @click="exportExcel">导出学员信息</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="deviceInfo-content xytable">
        <el-table :data="planInfo.ktUserPlanlist?newUserlist:[]" style="width: 100%" id="xueyuanTable">
          <!-- 头像、名称、手机号、部门、岗位、性别、学习状态 -->
          <el-table-column prop="avatarurl" label="头像">
            <template slot-scope="scope">
              <el-avatar size="medium" :src="getTxurl(scope.row)"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column prop="realName" label="名称">
          </el-table-column>
          <el-table-column prop="phone" label="手机号">
          </el-table-column>
          <el-table-column prop="orgName" label="部门">
          </el-table-column>
          <el-table-column prop="gwName" label="岗位">
          </el-table-column>
          <el-table-column prop="sex" label="性别" width="70">
          </el-table-column>
          <el-table-column prop="state" label="学习状态" width="375">
            <template slot-scope="scope">
              <div class="xuexizhuangt">
                <div class="likeSatrt">
                  <div :style="'width:'+scope.row.xxbfb+'%'"></div>
                </div>
                <div class="disFlex between">
                  <div>已学:<span style="color: #0071BA;">{{scope.row.yxkcnum}}</span>/{{scope.row.jhkcnum}}</div>
                  <div>学习总时长：{{scope.row.xxztime}}小时</div>
                  <div>{{scope.row.xxbfb}}%</div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 10px;text-align: right;" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 50, 100]"
          :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper"
          :total="planInfo.ktUserPlanlist.length">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import FileSaver from 'file-saver'
  import XLSX from 'xlsx'
  export default {
    props: ['collapse', 'wjSrc', 'currentUser'],
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('联系方式不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('联系方式有误，请重新输入！'));
        } else {
          callback();
        }
      };
      return {
        circleUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        formInline: {
          keyword: '',
          kstate: '',
          rows: 10,
          page: 1
        },
        newUserlist: [],
        planInfo: {
          ktUserPlanlist: []
        },
        tableData: {
          rows: [],
          total: 0
        },
        txnanUrl: require('@/assets/images/notxnan.png'),
        txnvUrl: require('@/assets/images/notxnv.png'),
        txnoUrl: require('@/assets/images/nosex.png'),
        txadminUrl: require('@/assets/images/notxsex.png'),
        fileList: []
      }
    },
    methods: {
      getData: function(id) {
        this.$axios.get('/kt/ktProductLeanplan/detail.htm?id=' + id).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.planInfo = data.data;
            var fileList = data.data.filestr ? JSON.parse(data.data.filestr) : [];
            this.fileList = fileList.map((item) => {
              return {
                ...item,
                id: item.fileid,
                url: this.wjSrc + item.filepath
              }
            });
            this.newUserlist = data.data.ktUserPlanlist;
          } else {
            this.$message.error(data.message);
          }
        })
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      getTxurl: function(item) {
        if (item.avatarurl) {
          return this.wjSrc + item.avatarurl
        } else if (item.sex == '女') {
          return this.txnvUrl
        } else if (item.sex == '男') {
          return this.txnanUrl
        } else if (item.roleCode == "COM_ADMIN_AQKT") {
          return this.txadminUrl
        } else {
          return this.txnoUrl
        }
      },
      getSearchData: function() {
        var list = [];
        var rows = this.planInfo.ktUserPlanlist;
        rows.map((item) => {
          // 两个搜索条件
          if (this.formInline.keyword && this.formInline.kstate) {
            if ((item.realName.indexOf(this.formInline.keyword) || item.stuid.indexOf(this.formInline
                .keyword)) && item.kstate == this.formInline.kstate) {
              list.push(item)
            }
          } else if (this.formInline.keyword) {
            if (item.realName.indexOf(this.formInline.keyword) || item.stuid.indexOf(this.formInline.keyword)) {
              list.push(item)
            }
          } else if (this.formInline.kstate) {
            if (item.kstate == this.formInline.kstate) {
              list.push(item)
            }
          } else {
            list.push(item)
          }
        });
        this.newUserlist = list;
      },
      print: function() {
        this.$router.push('/printPlaninfo?id=' + this.$route.query.id);
      },
      // 导出学员信息
      exportExcel: function() {
        const wb = XLSX.utils.table_to_book(document.querySelector('#xueyuanTable'))
        const wbout = XLSX.write(wb, {
          bookType: 'xlsx',
          bookSST: true,
          type: 'array'
        })
        const blob = new Blob([wbout], {
          type: 'application/octet-stream'
        });
        var title = this.planInfo.planname + '-学员信息';
        FileSaver.saveAs(blob, `${title}.xlsx`)
      }
    },
    created: function() {
      // 计划详情
      if (this.$route.query.id) {
        this.getData(this.$route.query.id)
      }
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          console.log(val)
          this.getSearchData();
        },
        deep: true //true 深度监听
      }
    },
  }
</script>
<style>
  .deviceInfo {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
  }

  .deviceInfo-header {
    height: 70px;
    border-bottom: 1px solid #efefef;
    padding: 0 30px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #333333;
    font-size: 16px;
    font-weight: 500;
  }

  .deviceInfo-content {
    padding: 20px;
  }

  .boughtTable {
    line-height: 38px;
    text-align: left;
    font-size: 14px;
  }

  .boughtTable td {
    padding-left: 20px;
    width: 140px;
    border: 1px solid #efefef;
  }

  .boughtTd1 {
    height: 38px;
    background-color: #f6f6f6;
    width: 105px;
  }

  .likeSatrt {
    height: 6px;
    opacity: 1;
    background: #f5f5f5;
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .likeSatrt div {
    background-color: #0071BA;
    height: 6px;
    opacity: 1;
    border-radius: 8px;
    width: 50%;
  }

  .xuexizhuangt {
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: right;
    color: #8c8c8c;
  }

  .kctable .el-table th {
    background-color: #EFEFEF;
  }

  .kctable .el-table td {
    background-color: #F6F6F6;
  }

  .xytable .el-table th {
    background-color: #FAFAFA;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/DeviceInfo.vue